import React, { useContext, useState } from 'react';
import { Field, FieldRenderProps, Form, FormRenderProps } from 'react-final-form';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Button, FormContent, Input, LocaleContext, ReCaptchaPolicy } from 'shared';
import { required as requiredValidator } from 'utils/formValidators';

import { FormLinkRegister, FormLinkResetPassword } from './LoginForm.styles';
import { LoginFormProps } from './LoginForm.types';

export const LoginForm = ({
  onSubmit,
  onShowResetPasswordForm,
  onShowRegistrationForm,
  isSubmitFailed,
}: LoginFormProps) => {
  const localeContext = useContext(LocaleContext);
  const [isCaptchaFilled, setCaptchaFilled] = useState(false);
  const required = requiredValidator(localeContext.formatMessage({ id: 'FORM.REQUIRED' }));

  const handleVerifyCaptcha = (change: (name: string, value?: any) => void) => (response: string) => {
    change('captchaResponse', response);
    setCaptchaFilled(true);
  };

  return (
    <FormContent className="form login-form">
      <Form onSubmit={onSubmit} validateOnBlur={false}>
        {({ handleSubmit, submitting, form: { change } }: FormRenderProps) => {
          return (
            <form onSubmit={handleSubmit} action="">
              <Field name="email" validate={required}>
                {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
                  <Input
                    label={localeContext.formatMessage({ id: 'LOGIN.FORM.EMAIL' })}
                    input={input}
                    meta={{
                      ...meta,
                      submitError:
                        isSubmitFailed && !submitting
                          ? localeContext.formatMessage({ id: 'LOGIN.FORM.FAILED' })
                          : meta.submitError,
                    }}
                    className="login-form__email"
                  />
                )}
              </Field>
              <Field name="password" validate={required}>
                {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
                  <Input
                    label={localeContext.formatMessage({ id: 'LOGIN.FORM.PASSWORD' })}
                    input={{ ...input, type: 'password', autoComplete: 'new-password' }}
                    meta={meta}
                    className="login-form__password"
                  />
                )}
              </Field>

              <FormLinkResetPassword onClick={onShowResetPasswordForm} className="login-form__reset-password">
                <span>{localeContext.formatMessage({ id: 'LOGIN.FORM.RESET-PASSWORD' })}</span>
              </FormLinkResetPassword>

              <GoogleReCaptcha onVerify={handleVerifyCaptcha(change)} />

              <ReCaptchaPolicy />

              <FormLinkRegister onClick={onShowRegistrationForm} className="login-form__register">
                <span>{localeContext.formatMessage({ id: 'LOGIN.FORM.REGISTER' })}</span>
              </FormLinkRegister>

              <Button type="leading" className="login-form__submit" disabled={submitting || !isCaptchaFilled}>
                {localeContext.formatMessage({ id: 'LOGIN.FORM.CONFIRM' })}
              </Button>
            </form>
          );
        }}
      </Form>
    </FormContent>
  );
};
